/* The Parade: animals march along the road (the line glides smoothly, each walker bobs stop-motion on twos). Scrolling down they march right,
   scrolling up they turn round. Hover or focus one and the whole parade stops while it waves. */
(function () {
  'use strict';
  var WH = window.WH;
  if (!WH) return;
  WH.register('parade', function (sec) {
    var march = sec.querySelector('[data-march]'), line = sec.querySelector('[data-line]');
    var walkers = Array.prototype.slice.call(sec.querySelectorAll('[data-walker]'));
    var bodies = walkers.map(function (w) { return w.querySelector('[data-walker-body]'); });
    var x = 0, w = 1, dir = 1, paused = false, visible = false, waving = null;
    function measure() { w = Math.max(1, line.offsetWidth); x = -w * 0.5; }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(sec);
    else visible = true;
    walkers.forEach(function (a, i) {
      a.querySelector('.wh-walker__sign').style.setProperty('--sr', (i % 2 ? 3 : -3) + 'deg');
      var on = function () { paused = true; wave(i); };
      var off = function () { paused = false; };
      a.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') on(); });
      a.addEventListener('pointerleave', off);
      a.addEventListener('focus', on);
      a.addEventListener('blur', off);
    });
    function wave(i) {
      WH.sound.play('squeak');
      if (!WH.anim) return;
      waving = bodies[i];
      gsap.timeline({ onComplete: function () { if (waving === bodies[i]) waving = null; } })
        .set(bodies[i], { y: 0 })
        .to(bodies[i], { rotation: -10, duration: 0.09, ease: 'none' })
        .to(bodies[i], { rotation: 10, duration: 0.17, ease: 'none', repeat: 3, yoyo: true })
        .to(bodies[i], { rotation: 0, scaleY: 1.08, y: -14, duration: 0.17, ease: WH.sm('power1.out', 0.17) })
        .to(bodies[i], { scaleY: 1, y: 0, duration: 0.17, ease: WH.sm('power1.in', 0.17) });
    }
    if (WH.reduce) return;
    /* the line glides every display frame; the walking bob stays a stop-motion pose on the 12 fps clock */
    WH.onTick(function (dt) {
      if (!visible) return;
      var d = WH.scroll.dir;
      if (d !== dir) { dir = d; walkers.forEach(function (a) { a.classList.toggle('is-flip', dir < 0); }); }
      if (paused) return;
      x += 84 * dir * dt;
      if (x > 0) x -= w;
      if (x < -w) x += w;
      march.style.transform = 'translateX(' + x.toFixed(1) + 'px)';
    });
    WH.onFrame(function (f) {
      if (!visible) return;
      if (!paused) {
        bodies.forEach(function (b, i) {
          if (b === waving) return;
          var up = ((f >> 1) + i) % 2 === 0;
          b.style.transform = up ? 'translateY(-8px) rotate(' + (-4 * dir) + 'deg)' : 'translateY(0) rotate(' + (3 * dir) + 'deg)';
        });
      }
    });
  });
})();
